// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Zyyc","content":"styles_content__1qlIV"};